import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import AdminLayout from './AdminLayout';
import { AdminBidDetailInner } from './AdminBidDetail';
import { NewLayoutBar } from './AdminJobDetail';

const API_BASE = process.env.REACT_APP_API_BASE || 'https://app.titanelectricreno.com:8080/api';
function getToken() { try { return JSON.parse(localStorage.getItem('titan_session') || 'null')?.token; } catch { return null; } }
function apiFetch(path, opts = {}) {
  return fetch(`${API_BASE}${path}`, {
    ...opts,
    headers: { 'Content-Type': 'application/json', 'x-worker-token': getToken(), ...opts.headers },
  }).then(r => r.ok ? r.json() : r.json().then(e => Promise.reject(e)));
}

export default function AdminNewProjectDetail() {
  const { id } = useParams(); // project id
  const [bidId, setBidId] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    apiFetch(`/projects/${id}/bid`)
      .then(bid => setBidId(bid.id))
      .catch(() => setError('Could not load project bid. This project may not have a linked bid.'));
  }, [id]);

  if (error) return <AdminLayout><div style={{ padding: 40, color: '#ef4444' }}>{error}</div></AdminLayout>;
  if (!bidId) return <AdminLayout><div style={{ padding: 40, color: '#9ca3af' }}>Loading project…</div></AdminLayout>;

  // AdminBidDetailInner brings its own AdminLayout, so the bar goes in through a
  // slot rather than being rendered around it.
  return <AdminBidDetailInner bidId={bidId} projectId={id} headerSlot={<NewLayoutBar id={id} />} />;
}
